import { Component, Output, EventEmitter, ViewChild, Input } from '@angular/core';
import * as _ from 'lodash';
import { BaseEditComponent } from '@app/cp/shared/base-components/base-edit.component';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { OrderService } from '@app/cp/shared/services/order.service';
import { SaveMode } from '@app/cp/shared/enums/SaveMode';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { OrderBillDetailsComponent } from './order-bill-details/order-bill-details.component';
import { OrderBillBus } from '@app/cp/shared/models/OrderBillBus';
import { forkJoin } from 'rxjs';
import { OrderBillUIParam } from '@app/cp/shared/models/OrderBillUIParam';
import { CommonValues } from '@app/cp/shared/static/CommonValues';
import { OrderBillParamBus } from '../../shared/models/OrderBillParamBus';
import { MessageType } from '../../shared/enums/MessageType';
import { Message } from '../../shared/models/message';
import { DQOIOrderDisplaySettings } from '../../shared/models/DQOIDisplaySettings';

@Component({
    selector: 'order-bills',
    templateUrl: './order-bills.component.html',
    styleUrls: ['./order-bills.component.scss'],
    standalone: false
})
export class OrderBillsComponent extends BaseEditComponent<OrderBillBus, OrderService, null, null> {

    constructor(globals: GlobalsService, qry_rd: DQOIReferenceDataQuery, svc_data: OrderService) {
        super(globals, qry_rd);
        this.svc_data = svc_data;
        this.readOnly = false;
        this.saveMode = SaveMode.all;
        this.appCode = "OrderBill";
    }
    @ViewChild('LineItems') protected lineItems: OrderBillDetailsComponent;
    @Output() closed: EventEmitter<any> = new EventEmitter<any>();
    @Output() createInvoiceEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() createSupplierCreditEvent: EventEmitter<any> = new EventEmitter<any>();
    editing: boolean = true;
    saving: boolean = false;
    uiParam: OrderBillUIParam = new OrderBillUIParam();
    gridData: OrderBillBus[];
    orderId: any;
    @Input() dqoiOrderDisplaySettings: DQOIOrderDisplaySettings = new DQOIOrderDisplaySettings();
    cancel() {
        this.gridData = [];
        this.editing = false;
        this.closed.emit(false);
    }
    createInvoiceFromBill($event) {
        this.createInvoiceEvent.emit($event);
        this.closed.emit(false);
    }
    createSupplierCreditFromBill($event) {
        this.createSupplierCreditEvent.emit($event);
        this.closed.emit(false);
    }
    parentMessage(e: Message) {
        super.parentMessage(e);
        if (e.messageType === MessageType.close) {
            this.cancel();
        }

    }
    getData() {
        this.dataLoading = true;
        forkJoin(this.svc_data.getFromId(this.orderId), this.svc_data.getBillsForOrder(this.orderId))
            .subscribe(data => {
                console.log("order-bills-fj: ", data);
            });

        this.gridData = [];
        this.subs_data = this.svc_data.getBillsForOrder(this.orderId).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                var busObjs: OrderBillBus[] = [];
                if (info.primaryReturn != null) {
                    busObjs = info.primaryReturn as OrderBillBus[];
                }

                let arr = [];
                for (let i = 0; i < busObjs.length; i++) {

                    let busObj: OrderBillBus = new OrderBillBus(busObjs[i],false);
                    busObj.rowValid = true;
                    if (busObjs[i].hasInvoice)
                    {
                        busObj.hasInvoice = busObjs[i].hasInvoice;
                    }
                    arr.push(busObj);
                }

                this.gridData = arr; // info.primaryReturn as OrderBillBus[];
                this.dataLoading = false;
                this.lineItems.expandAll();
                this.saving = false;
            }
        });

    }
    saveAll() {
        this.saving = true;
        this.editing = false;
        this.dataLoading = true;
        let now: Date = DateFunctions.getDateNow();
        let busObj: OrderBillBus = new OrderBillBus(this.data);
        busObj.orderId = this.orderId;
        busObj.setCommon(this.globals.userId, now, this.globals.companyId);
        let orderDetailsX: OrderBillBus[] = this.lineItems.getChanged();
        for (let i = 0; i < orderDetailsX.length; i++) {
            orderDetailsX[i].setCommon(this.globals.userId, now, this.globals.companyId);
        }
        let deletedOrdBllBus: OrderBillBus = new OrderBillBus();
        deletedOrdBllBus.addDeletedItems(this.lineItems.getDeletedItems());
        if (CommonFunctions.hasArrayElementValue(deletedOrdBllBus.deletedItems)) {
            deletedOrdBllBus.orderId = CommonValues.Guid_Empty;
            deletedOrdBllBus.dateReceived = new Date();
            deletedOrdBllBus.receivedById = CommonValues.Guid_Empty;
            deletedOrdBllBus.amountBilled = 0;
            deletedOrdBllBus.orderBillStatusId = CommonValues.Guid_Empty;
            deletedOrdBllBus.insertDt = new Date();
            deletedOrdBllBus.updateDt = new Date();
        }
        var orderBillParamBus = new OrderBillParamBus();
        orderBillParamBus.orderBills = orderDetailsX;
        orderBillParamBus.deletedItems = this.lineItems.getDeletedItems();
        this.svc_data.saveOrderBills(orderBillParamBus).subscribe((info: BaseMessageInfo) => {
            console.log("save-ret", info);
             if (!info.saveError) {
                 this.saveSuccess();
                 this.lineItems.clearDeleted();
                 this.getData();
                 if (!this.globals.user.isZuggitUser) {
                     this.closed.emit(true);
                 }
                 this.saving = false;
             }
             else {
                 this.saveError(info.message);
                 this.saving = false;
             }
         });
    }
    setup(data: any) {
        this.orderId = data;
        this.getData();
    }
    canSaveLocal = false;
    onQuantityChanged(data: boolean) {
        this.canSaveLocal = data;
    }
    onChanged(data: boolean) {
        this.canSaveLocal = data;
    }
}
